/*! @license Firebase v3.7.6
Build: rev-d1c8cec
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase_app = require('./app/firebase_app');

var firebase = (0, _firebase_app.createFirebaseNamespace)(); 
exports.default = firebase;
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./~/firebase/app.js
// module id = 63
// module chunks = 2